import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import FormFeedback from './FormFeedback';

function WrappedFormSelect(props) {
  // react-final-form expects value to be the option object, not just value
  const { input, meta, options, ...rest } = props;
  // Find the selected option object
  const selectedOption = options.find(opt => opt.value === input.value) || null;

  return (
    <>
      <Select
        {...rest}
        options={options}
        value={selectedOption}
        onChange={option => input.onChange(option ? option.value : '')}
        onBlur={() => input.onBlur(input.value)}
      />
      {meta.dirty && input.value === '' && (
        <FormFeedback positive={false}>This field is required.</FormFeedback>
      )}
    </>
  );
}

WrappedFormSelect.propTypes = {
  meta: PropTypes.shape({
    dirty: PropTypes.bool
  }).isRequired,
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.string
      }),
      PropTypes.any
    ]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string
    })
  ).isRequired
};

export default WrappedFormSelect;
